import { makeStyles } from '@mui/styles';
import { COLOR_GRAY_70, COLOR_PURPLE } from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  mainContainer: {
    padding: theme.spacing(4, 3),

    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(9, 16.62),
    },
  },
  mainBox: {
    backgroundColor: theme.palette.common.white,
    borderRadius: 20,
    padding: theme.spacing(4, 2),
  },
  title: {
    fontSize: 32,
    color: COLOR_GRAY_70,
    textAlign: 'center',
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(6),

    '& span': {
      fontWeight: 700,
      color: COLOR_PURPLE,
    },
  },
}));
